import React from "react";
import { Marker } from "react-map-gl/mapbox";
import { MAP_COLORS } from "../utils/colors";

export interface MapMarkerProps {
  longitude: number;
  latitude: number;
  color: string;
  isSelected: boolean;
  isHovered?: boolean;
  onClick: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export const MapMarker: React.FC<MapMarkerProps> = ({
  longitude,
  latitude,
  color,
  isSelected,
  isHovered = false,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  // Calculate styles based on hover state
  const getMarkerStyle = () => {
    const baseStyle = {
      backgroundColor: color,
      borderRadius: "50%",
      width: "14px",
      height: "14px",
      border: `2px solid ${MAP_COLORS.MARKER_BORDER}`,
      cursor: "pointer",
      transition: "all 0.2s ease",
    };

    if (isHovered) {
      return {
        ...baseStyle,
        transform: "scale(1.3)",
        boxShadow: `0 0 12px ${color}, 0 4px 8px rgba(0,0,0,0.3)`,
        zIndex: 10,
      };
    }

    return {
      ...baseStyle,
      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
    };
  };

  return (
    <Marker
      longitude={longitude}
      latitude={latitude}
      anchor="bottom"
      onClick={(e: any) => {
        e.originalEvent.stopPropagation();
        onClick();
      }}
    >
      <div
        className={`marker ${isSelected ? "selected" : ""}`}
        style={getMarkerStyle()}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    </Marker>
  );
};
